import React, { useEffect } from 'react';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import TIME_ZONES from '../../constants/timeZones';
import CustomDropdownMenu from '../common/CustomDropdownMenu';

const ActualizationDate = ({
  actualizationDate,
  amountCalculatedDate,
  checkActualization,
  projectZone,
  sideMenuCollapsed,
}) => {
  useEffect(() => {
    let timer = setTimeout(async function doActualization() {
      await checkActualization();
      timer = setTimeout(doActualization, 60 * 1000);
    }, 60 * 1000);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buildList = () => (
    <CustomDropdownMenu>
      {!sideMenuCollapsed ? (
        <li key="-1" style={{ fontSize: 14, cursor: 'default' }}>
          {`actualization time: ${actualizationDate} (${TIME_ZONES[projectZone]})`}
        </li>
      ) : null}
      <li key="-2" style={{ fontSize: 14, cursor: 'default' }}>
        Payment.amountCalculated actualization time: {amountCalculatedDate} (
        {TIME_ZONES[projectZone]})
      </li>
    </CustomDropdownMenu>
  );

  return (
    <div style={{ marginLeft: 10, maxWidth: 700 }}>
      <Dropdown dropdownRender={() => buildList()} trigger={['click']}>
        <a
          className="ant-dropdown-link"
          href="#"
          style={{ textDecoration: 'none', color: '#808080', fontFamily: 'sans-serif' }}
        >
          <div
            style={{
              fontSize: 14,
              position: 'relative',
              width: 'max-content',
              cursor: 'pointer',
              userSelect: 'none',
              lineHeight: 1,
            }}
          >
            Actualization time:
            {sideMenuCollapsed ? ` ${actualizationDate} (${TIME_ZONES[projectZone]})` : ''}
            <DownOutlined
              style={{ color: '#808080', margin: '0 5px', fontSize: 11, verticalAlign: 'middle' }}
            />
          </div>
        </a>
      </Dropdown>
    </div>
  );
};

export default ActualizationDate;
